import React from 'react';
import RenderQRCode from '../../cmp/qrcodeloader/RenderQRCode';
import ShareBar from '../../cmp/ShareBar';
import LogoRender from '../../cmp/LogoRender';

function QrCodeInternal(props) {
    const url = new URL(document.location.href)
    url.pathname = "/"
    const home = url.href
    url.pathname = "/create-account"
    const signup = url.href
    url.pathname = "/login"
    const login = url.href
    return (
        <div className="min-vh-100 bg-light w-100">
            <div className={"container"} style={{paddingTop:100}}>
                <div className="text-center mb-4">
                    <LogoRender linked showDefault/>
                </div>
                <div className="row">
                    <RenderCard title={"Home page"} url={home}/>
                    <RenderCard title={"Sign up page"} url={signup}/>
                    <RenderCard title={"Login page"} url={login}/>
                </div>
            </div>
        </div>

    );
}
function RenderCard({title, url}){
    return   <div className="col-lg-4 mb-4">
        <div className="card shadow-sm">
            <div className="card-header">
                <div className="text-center"><strong>{title}</strong></div>
            </div>
            <div className="card-body">
                <div className="text-center">
                    <RenderQRCode url={url} size={size}/>
                </div>
            </div>
            <div className="card-footer d-flex align-items-center justify-content-center">
                <ShareBar link={url} />
            </div>
        </div>
    </div>
}

export default QrCodeInternal;
